import { Box, Button, Typography } from "@mui/material";
import { RightArrow } from "../../utils/icon/Landing-Page/Icon";
import { FeaturesCard } from "./LandingPageElements";
import { Cards } from "../../utils/data/Landing-Page/data";


export const ThirdPage = () => {
    
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ width: '80%', py: 3 }}>
                    <Typography sx={{ fontSize: '20px', color: '#0057D5', fontWeight: '700', py: 4 }}>FEATURES</Typography>
                    <Typography sx={{ fontSize: '40px', color: '#040815', fontWeight: '700', py: 2 }}>Unleash the Full Potential of<br /> Your Project Management</Typography>
                    <Typography sx={{ fontSize: '20px', color: '#474747', fontWeight: '500', py: 2 }}>Discover the robust and transformative features that elevate<br /> your project management experience.</Typography>
                    <Button sx={{ color: '#fff', background: '#FF2800', height: '40px', my: 2, mb: 4, borderRadius: '40px', mx: '10px', textTransform: 'capitalize', '&:hover': { background: '#FF280099' }, px: 3 }}><Typography sx={{ mr: 2 }}>Explore Features</Typography><RightArrow /></Button>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        {Cards.map((e, i) => (
                            <FeaturesCard key={i} data={e} />
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}